export default {"src":"/_next/static/media/buildpass-small.3979a60b.svg","height":30,"width":17,"blurWidth":0,"blurHeight":0};